var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "shared-content-page" },
    [
      _c("shared-link-list", {
        staticClass: "shared-link-list",
        attrs: {
          sharedLinkId: _vm.sharedLinkId,
          novelId: _vm.novelId,
          contentKey: _vm.contentKey,
        },
        on: { contentSelect: _vm.onContentSelect },
      }),
      _c("shared-link-content", {
        staticClass: "shared-link-content",
        attrs: {
          sharedLinkId: _vm.sharedLinkId,
          novelId: _vm.novelId,
          contentKey: _vm.contentKey,
          kind: _vm.kind,
        },
      }),
      _c("shared-link-comment", {
        staticClass: "shared-link-comment",
        attrs: {
          sharedLinkId: _vm.sharedLinkId,
          novelId: _vm.novelId,
          contentKey: _vm.contentKey,
          kind: _vm.kind,
        },
      }),
      !_vm.isAgreed
        ? _c("div", { staticClass: "mask" }, [
            _c("div", { staticClass: "box" }, [
              _c("h1", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("sharedContentPage.title"))),
              ]),
              _c("div", { staticClass: "description" }, [
                _c("span", [
                  _vm._v(
                    " " + _vm._s(_vm.$t("sharedContentPage.description")) + " "
                  ),
                ]),
                _c("span", { staticClass: "danger" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("sharedContentPage.warningMessage")) +
                      " "
                  ),
                ]),
                _c(
                  "div",
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("sharedContentPage.policyNoticePrefix"))
                      ),
                    ]),
                    _c(
                      "router-link",
                      {
                        staticClass: "policy",
                        attrs: { to: { name: "shared" }, target: "_blank" },
                      },
                      [_vm._v(_vm._s(_vm.$t("sharedContentPage.policyLink")))]
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("sharedContentPage.policyNoticeSuffix"))
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "agreement",
                  on: { click: _vm.onClickCheckbox },
                },
                [
                  _c("checkbox-icon", {
                    staticClass: "checkbox",
                    attrs: { isChecked: _vm.isChecked },
                  }),
                  _c(
                    "router-link",
                    {
                      staticClass: "policy",
                      attrs: { to: { name: "shared" }, target: "_blank" },
                    },
                    [_vm._v(_vm._s(_vm.$t("sharedContentPage.policyLink")))]
                  ),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("sharedContentPage.agreementText"))),
                  ]),
                ],
                1
              ),
              _c(
                "button",
                {
                  staticClass: "button",
                  attrs: { disabled: !_vm.isChecked },
                  on: { click: _vm.onClickStart },
                },
                [_vm._v(_vm._s(_vm.$t("sharedContentPage.startButton")))]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }